<template>
    <div class="filter-bar">
        <div class="filter-bar__left">
            <div class="results">
                <span class="number" id="filter-bar-total">-</span>
                <span class="text">resultaten</span>
            </div>
        </div>
        <div class="filter-bar__right">
            <div class="filter-toggle">
                <svg class="ham hamRotate ham-filter" viewBox="0 0 100 100" width="60">
                    <path class="line top" d="m 70,33 h -40 c 0,0 -8.5,-0.149796 -8.5,8.5 0,8.649796 8.5,8.5 8.5,8.5 h 20 v -20"></path>
                    <path class="line middle" d="m 70,50 h -40"></path>
                    <path class="line bottom" d="m 30,67 h 40 c 0,0 8.5,0.149796 8.5,-8.5 0,-8.649796 -8.5,-8.5 -8.5,-8.5 h -20 v 20"></path>
                </svg>
                <span>Filteren</span>
            </div>
            <div v-if="$store.state.filterState == true" class="filter-delete" @click="resetAllFilters" id="delete-filters">
                Alle filters verwijderen
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        props: ['FilterBar'],

        methods: {
            resetAllFilters() {
                this.$store.commit('resetFilters');
            }
        },
    };
</script>